export const getMemberDayOffer = async (
  params?: Record<string, any>,
  headers?: HeadersInit,
) => {
  const queryParams = new URLSearchParams({
    action: 'memberDayOffer',
    ...params,
  }).toString();
  const url = `/api/app-wrapper?${queryParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw {
      status: response.status,
      message: errorData?.errorMessage || 'Failed to fetch member day offer',
      raw: errorData,
    };
  }

  return response.json();
};
